import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithDocs_1 from '../../../../../libraries/Images/createAConnectionWithDocs_1.png';
import createAConnectionWithDocs_2 from '../../../../../libraries/Images/createAConnectionWithDocs_2.png';
import createAConnectionWithDocs_3 from '../../../../../libraries/Images/createAConnectionWithDocs_3.png';
import createAConnectionWithDocs_4 from '../../../../../libraries/Images/createAConnectionWithDocs_4.png';
import createAConnectionWithDocs_5 from '../../../../../libraries/Images/createAConnectionWithDocs_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithdocs">
                1.&nbsp;{translate('createaconnectionwithdocs')}
            </Typography>
            <p>接続を作成するように"新規追加"ボタンをクリック</p>
            <Zoom>
                <img src={createAConnectionWithDocs_1} width="75%" />
            </Zoom>
            <p>連携できるアプリの一覧が表示されるので、その中から「Google Docs」を選択します。</p>
            <Zoom>
                <img src={createAConnectionWithDocs_2} width="75%" />
            </Zoom>
            <p>「Google Docs」をクリックすると、ユーザーのGoogleアカウント選択画面が表示されます。接続に使用するアカウントを選択してください。</p>
            <Zoom>
                <img src={createAConnectionWithDocs_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>アカウントを選択すると、「RPA CLOUD」がユーザーに代わってアクセスを要求します。 「RPA CLOUD」に上記のアクセス権限を付与することに同意し、「許可」をクリックします。</p>
            <Zoom>
                <img src={createAConnectionWithDocs_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>接続が正常に作成されると、「Google Docs」 タグが表示されます。</p>
            <Zoom>
                <img src={createAConnectionWithDocs_5} width="50%"/>
            </Zoom>
            <p>このタグに含まれる<strong>プロバイダー ID</strong> を使用して「Google Docs」に関する機能を実行します。</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);